import React, { useEffect, useState } from 'react';
import { IconVideo } from '../../../Icon';
import { ModalComp } from '../../../HtmlInputs';
import { FaBars } from 'react-icons/fa';
import { useGetAllEncryptedVideoUrlQuery } from '../../../../Apis/LMSService/WebsiteDemoApi';
import { useLocation } from 'react-router-dom';
import { convertData, rtkErrorRead, toastNotify } from '../../../../Helper';
import tblWebsiteDemoVideo, {
  tblWebsiteDemoVideoDocumentDetails,
} from '../../../../Interfaces/DataBase/tblWebsiteDemoVideo';

interface Video {
  id: number;
  title: string;
  url: string;
}

const ShowDemoVideo: React.FC = () => {
  const [showDemoVideo, setShowDemoVideo] = useState<boolean>(false);
  const [videoData, setVideoData] = useState<Video[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);
  const [allVideoUrl, setAllVideoUrl] = useState<tblWebsiteDemoVideo[]>([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(true);
  const getAllEncryptedVideoUrl = useGetAllEncryptedVideoUrlQuery(null, { skip: window.location.origin.includes('localhost') });
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (getAllEncryptedVideoUrl.isError) {
      rtkErrorRead(getAllEncryptedVideoUrl.error);
    } else {
      const dbData: tblWebsiteDemoVideo[] = convertData(
        getAllEncryptedVideoUrl.data?.result
      );
      setAllVideoUrl(dbData || []);
    }
  }, [getAllEncryptedVideoUrl]);

  const isDevToolsOpen = (): boolean => {
    const widthThreshold = window.outerWidth - window.innerWidth > 100;
    const heightThreshold = window.outerHeight - window.innerHeight > 100;
    return widthThreshold || heightThreshold;
  };

  const decryptUrl = (encryptedUrl: string): string => {
    let decryptedUrl = encryptedUrl
      .replace(/\^/g, '/')
      .replace(/~/g, '[TEMP_T]')
      .replace(/\*/g, 'a')
      .replace(/@/g, 'e')
      .replace(/#/g, 'i')
      .replace(/\$/g, 'o')
      .replace(/!/g, 'u')
      .replace(/\[TEMP_T\]/g, 't');
    if (decryptedUrl.endsWith('/')) {
      decryptedUrl = decryptedUrl.slice(0, -1);
    }
    return decryptedUrl;
  };

  useEffect(() => {
    if (showDemoVideo) {
      const disableRightClick = (e: MouseEvent) => e.preventDefault();
      const disableInspectShortcuts = (e: KeyboardEvent) => {
        if (
          e.ctrlKey &&
          ['u', 'U', 'i', 'I', 'j', 'J', 'c', 'C'].includes(e.key)
        ) {
          e.preventDefault();
        }
        if (e.key === 'F12') {
          e.preventDefault();
        }
      };

      document.addEventListener('contextmenu', disableRightClick);
      document.addEventListener('keydown', disableInspectShortcuts);

      return () => {
        document.removeEventListener('contextmenu', disableRightClick);
        document.removeEventListener('keydown', disableInspectShortcuts);
      };
    }
  }, [showDemoVideo]);

  const matchPath = (
    currentPath: string,
    video: tblWebsiteDemoVideo
  ): boolean => {
    const filterData = video.PageUrl?.split(':')?.[0].replace(/\/$/, '');
    let urlData = '';
    const length = video.PageUrl?.split(':').length || 0;
    if (length > 1) {
      urlData = currentPath
        .split('/')
        .slice(0, (length - 1) * -1)
        .join('/');
    } else {
      urlData = currentPath;
    }

    if (length > 1) {
      return (
        filterData?.toLowerCase() === urlData.toLowerCase() ||
        filterData?.toLowerCase() === currentPath
      );
    } else {
      return filterData?.toLowerCase() === urlData.toLowerCase();
    }
  };

  const currentVideo = allVideoUrl.find((video) =>
    matchPath(currentPath, video)
  );

  const videoSrc =
    currentVideo?.DocumentDetails?.map((x, i) => ({
      id: i,
      title: x.Title,
      url: `https://istor1.cloudinfinit.com/${decryptUrl(
        x?.EncryptedDocumentUrl || ''
      )}`,
    })) || [];

  const handleOpenVideo = () => {
    if (isDevToolsOpen()) {
      toastNotify(
        'Press Ctrl minus(-) three times. Your Screen Resolution is not supported.'
      );
      return;
    }
    if (videoSrc.length > 0) {
      setSelectedVideo(videoSrc[0] as Video);
      setVideoData(videoSrc as Video[]);
    }
    setShowDemoVideo(true);
  };

  const handleSelectVideo = (video: Video) => {
    setSelectedVideo(video);
  };

  return (
    <div className="shrink-0">
      {showDemoVideo && (
        <ModalComp
          sizeClass="md:w-[800px] xl:w-[1200px]"
          title="Video Player"
          open={showDemoVideo}
          closeBtnView={false}
          onClose={() => setShowDemoVideo(false)}
        >
          <div className="flex h-[600px]">
            {/* Sidebar */}
            {currentVideo && videoData.length > 0 && (
              <div
                className={`transition-all duration-300 ${isSidebarOpen ? 'w-1/4' : 'w-[64px] overflow-hidden'
                  } bg-gray-100 dark:bg-gray-800 p-4`}
              >
                <button
                  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                  className="mb-4 p-2 bg-gray-300 dark:bg-gray-700 rounded"
                >
                  <FaBars />
                </button>
                {isSidebarOpen && (
                  <ul className="space-y-2">
                    {videoData.map((video) => (
                      <li
                        key={video.id}
                        className={`p-2 rounded cursor-pointer ${selectedVideo?.id === video.id
                          ? 'bg-blue-500 text-white'
                          : 'bg-white dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600'
                          }`}
                        onClick={() => handleSelectVideo(video)}
                      >
                        {video.title}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            <div
              className={`flex-1 ${currentVideo && videoData.length > 1 ? 'w-3/4' : 'w-full'
                } p-4`}
            >
              <div className="relative h-full">
                {currentVideo && selectedVideo ? (
                  <video
                    src={selectedVideo.url}
                    controls
                    autoPlay
                    className="w-full h-auto rounded"
                  />
                ) : (
                  <div className="h-full w-full flex justify-center items-center">
                    <div>Video not available for this page.</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </ModalComp>
      )}
      <span
        onClick={handleOpenVideo}
        className="cursor-pointer relative flex h-9 w-9 items-center justify-center rounded-full border border-black/10 dark:border-white/10 bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60 transition-colors"
      >
        <IconVideo />
      </span>
    </div>
  );
};

export default ShowDemoVideo;
